import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { IStorageService } from './storage.interface';

@Injectable({
  providedIn: 'root'
})
export class StorageService implements IStorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {}

  async create(): Promise<IStorageService> {
    this._storage = await this.storage.create();
    return this;
  }

  async get(key: string): Promise<any> {
    if (!this._storage) {
      await this.create();
    }
    return this._storage!.get(key);
  }

  async set(key: string, value: any): Promise<any> {
    if (!this._storage) {
      await this.create();
    }
    return this._storage!.set(key, value);
  }

  async remove(key: string): Promise<any> {
    if (!this._storage) {
      await this.create();
    }
    return this._storage!.remove(key);
  }

  async clear(): Promise<void> {
    if (!this._storage) {
      await this.create();
    }
    return this._storage!.clear();
  }
}